export default "__VITE_PUBLIC_ASSET__d2e5b701__"